import React from 'react'
import PropTypes from 'prop-types'

import { TableRow, TableCell, Radio } from '@material-ui/core'

import RadioGroupContext from 'contexts/RadioGroupContext'

const TableRadioGroupRow = ({ name, value, data, children, ...props }) => {
  const context = React.useContext(RadioGroupContext)

  const handleClickRow = () => {
    context.selectValue(value, data)
  }

  const isSelected = () => context.selectedValue === value

  return (
    <TableRow selected={isSelected()} onClick={handleClickRow} {...props}>
      <TableCell>
        <Radio name={name} value={value} checked={isSelected()} />
      </TableCell>
      {children}
    </TableRow>
  )
}

TableRadioGroupRow.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  data: PropTypes.any,
}

export default TableRadioGroupRow
